import axios from "axios";
import Qs from "qs";
import Vue from "vue";
import _ from "lodash";
// import { Toast } from "vant";
// import { Message } from 'element-ui'; // 消息提示框组件

// 环境的切换
if (process.env.NODE_ENV == "development") {
  // axios.defaults.baseURL = 'http://172.20.60.100:8089';
  axios.defaults.baseURL = "https://klmucar.com";
  // axios.defaults.baseURL = 'http://seasawboms.natapp4.cc'
  // axios.defaults.baseURL = 'http://118.193.41.189:8081'
} else if (process.env.NODE_ENV == "debug") {
  // axios.defaults.baseURL = 'http://172.20.60.100:8089';
  axios.defaults.baseURL = "https://klmucar.com";
  // axios.defaults.baseURL = 'https://approvedplus.hk-audi.com'
  // axios.defaults.baseURL = 'http://118.193.41.189:8081'
} else if (process.env.NODE_ENV == "production") {
  // axios.defaults.baseURL = 'http://172.20.60.100:8089';
  axios.defaults.baseURL = "https://klmucar.com";
  // axios.defaults.baseURL = 'https://approvedplus.hk-audi.com'
  // axios.defaults.baseURL = 'http://118.193.41.189:8081'
}

// loading框设置局部刷新，且所有请求完成后关闭loading框
// let loading;
//声明一个对象用于存储请求个数
let needLoadingRequestCount = 0;

// function startLoading() {
//     loading = Vue.prototype.$loading({
//         lock: true,
//         text: 'Loading...',
//         background: 'rgba(255, 255, 255, 0.9)',
//         // customClass: 'loading'
//         target: document.querySelector('.loading') //设置加载动画区域
//     });
// }

// function endLoading() {
//     // setTimeout(() => {
//     loading.close();
//     // }, 200)
// }

// const tryCloseLoading = () => {
//     if (needLoadingRequestCount === 0) {
//         endLoading()
//     }
// }

function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    // startLoading();
  }
  needLoadingRequestCount++;
}

function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return;
  needLoadingRequestCount--;
  // if (needLoadingRequestCount === 0) {3
  // _.debounce(tryCloseLoading, 100)() //延迟100ms
  // }
}

// 设置请求超时时间
axios.defaults.timeout = 66666;
axios.defaults.withCredentials = false;

// 设置post请求头
let urlencoded = axios.create({
  headers: {
    "Content-type": "application/x-www-form-urlencoded;charset=UTF-8"
  }
});

let formoctetstream = axios.create({
  headers: {
    "Content-type": "application/x-www-form-urlencoded;charset=UTF-8"
  },
  responseType: "blob"
});

axios.defaults.headers.post["Content-Type"] = "application/json;charset=UTF-8";

// 请求拦截
axios.interceptors.request.use(
  config => {
    // console.log('config', config)
    // if (config.method === 'post') {
    //     config.data = Qs.stringify(config.data);
    // }
    showFullScreenLoading();
    return config;
  },
  error => {
    tryHideFullScreenLoading();
    // Message.error({ message: '請求超時!' });
    return Promise.error(error);
  }
);

// 响应拦截
axios.interceptors.response.use(
  response => {
    tryHideFullScreenLoading();
    return response;
  },
  error => {
    tryHideFullScreenLoading();
    return Promise.reject(error);
  }
);

/**
 * post方法，对应postoctetstream请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function postoctetstream(url, params) {
  return new Promise((resolve, reject) => {
    // formjson.post(url, params)
    formoctetstream
      .post(url, Qs.stringify(params))
      .then(res => {
        resolve(res.data);
        // Loading.service(true).close();
        //  Message({message: '请求成功', type: 'success'});
      })
      .catch(err => {
        reject(err.data);
        // Loading.service(true).close();
        // Message({ message: '數據加載失敗, "刷新重试"或"聯系管理員"', type: 'error' });
      });
  });
}

/**
 * post方法，对应postform请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function postform(url, params) {
  return new Promise((resolve, reject) => {
    urlencoded
      .post(url, Qs.stringify(params))
      .then(res => {
        resolve(res.data);
        // Loading.service(true).close();
        //  Message({message: '请求成功', type: 'success'});
      })
      .catch(err => {
        reject(err.data);
        // Loading.service(true).close();
        // Message({ message: '數據加載失敗, "刷新重试"或"聯系管理員"', type: 'error' });
      });
  });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params)
      .then(res => {
        resolve(res.data);
        //  Loading.service(true).close();
        //  Message({message: '请求成功', type: 'success'});
      })
      .catch(err => {
        reject(err.data);
        //  Loading.service(true).close();
        // Message({ message: '數據加載失敗, "刷新重试"或"聯系管理員"', type: 'error' });
      });
  });
}



// WEBPACK FOOTER //
// ./src/untils/axios.js